angular.module('core')
    .provider('dblDebugProvider', function() {

    var provider = {
        $get: ['$log', '$rootScope', function($log, $rootScope) {

            var enabled = false;
            var debugHandler;
            var activateHandler;

            function activateDebugListener () {
                activateHandler = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams) {
                    if(toParams && toParams.debug === 'on') {
                        if(enabled === false) {
                            _this.enableDebug();
                        }
                    } else if (toParams && toParams.debug === 'off') {
                        if(enabled === true) {
                            _this.disableDebug();
                        }
                    }
                });
            }

            var _this = {
                //activate debug listener
                activateDebugging: activateDebugListener,
                deactivateDebugging: function() {
                    activateHandler();
                },

                //turn on debugging
                enableDebug: function() {
                    enabled = true;
                    debugHandler = $rootScope.$on('dbl-debug', function (event, obj) {
                        $log.debug('dbl-debug:', obj);
                    });
                    $log.debug("dblDebug logging: [On]");
                    $log.debug("listenersCount", $rootScope.$$listenerCount["dbl-debug"]);
                },

                //turn off debugging
                disableDebug: function() {
                    enabled = false;
                    if(debugHandler) {
                        debugHandler();
                    }
                    $log.debug("dblDebug logging: [Off]");
                    $log.debug("listenersCount", $rootScope.$$listenerCount["dbl-debug"]);
                }
           };
            return _this;
        }]
    };
    return provider;
});